<template>
    <div>
        <table class="responsive-table">
            <thead>
                <slot name='head'></slot>
            </thead>
            <tbody>
                <slot name='body'></slot>
            </tbody>
        </table>
    </div>
</template>
<script>
    export default {
        name:'BaseTable'
    }
</script>